import { render, staticRenderFns } from "./CommonUse.vue?vue&type=template&id=66f18747&scoped=true"
import script from "./CommonUse.vue?vue&type=script&lang=js"
export * from "./CommonUse.vue?vue&type=script&lang=js"
import style0 from "./CommonUse.vue?vue&type=style&index=0&id=66f18747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f18747",
  null
  
)

export default component.exports